import { LayoutDashboard, Grid3X3, Users, Settings, LogOut, Megaphone, BookOpen, Download, Network } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';

const menuItems = [
  { path: '/', icon: LayoutDashboard, label: '首页' },
  { path: '/apps', icon: Grid3X3, label: '应用管理' },
  { path: '/users', icon: Users, label: '用户管理' },
  { path: '/ads', icon: Megaphone, label: '广告管理' },
  { path: '/ad-network', icon: Network, label: '广告联盟' },
  { path: '/downloads', icon: Download, label: '下载管理' },
  { path: '/api-docs', icon: BookOpen, label: 'API文档' },
  { path: '/settings', icon: Settings, label: '系统设置' },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="w-64 bg-slate-800 min-h-screen border-r border-slate-700 flex flex-col">
      <div className="p-6 border-b border-slate-700">
        <h1 className="text-xl font-bold text-white">统一账号管理</h1>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                isActive
                  ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/20'
                  : 'text-slate-300 hover:bg-slate-700 hover:text-white'
              }`}
            >
              <Icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </button>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-700">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-slate-400 hover:text-red-400 hover:bg-red-500/10 transition-all"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium">退出登录</span>
        </button>
      </div>
    </aside>
  );
}